export const ERRORED = 'auth/errored';
export const LOGOUT_REQUESTED = 'auth/logout_requested';
export const LOGOUT = 'auth/logout';
export const TOKEN_REQUESTED = 'auth/token_requested';
export const TOKEN_SUCCESS = 'auth/token_success';
export const UPDATE_TOKEN_REQUESTED = 'shared/update_token_requested';
export const UPDATE_TOKEN = 'shared/update_token';
export const AUTH_SUCCESS = 'auth/auth_success';
